module.exports = __webpack_public_path__ + "img/gb13871-92_110x140x12.prt.34ad4dec.jpg";